import AuthLayout from '../../layout/auth/authLayout'
import { RouteObject } from 'react-router-dom'
import LoginPage from './login'
import ConfirmationPage from './confirmation'
import Profile from './profile'
import TwoFactorPage from './twoFactor'
import Impersonate from './impersonate'
import ErrorBug from 'components/errors/bugs'

export const authRoutes: RouteObject[] = [
    {
        path: 'auth',
        element: <AuthLayout />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                path: 'login',
                element: <LoginPage />,
            },
            {
                index: false,
                path: 'confirmation',
                element: <ConfirmationPage />,
            },
            {
                index: false,
                path: 'two-factor',
                element: <TwoFactorPage />,
            },
            {
                index: false,
                path: 'profile',
                element: <Profile />,
            },
            {
                index: false,
                path: 'impersonate',
                element: <Impersonate />,
            },
        ],
    },
]
